/**
 * Pick-type-aware line movement sentiment for watch list display.
 * Used by PickItem (Phase 0) and characterized in unit tests before UI wiring.
 *
 * @param {string} pickType - home | away | over | under
 * @param {number} watchLine - line when the pick was watched (home spread or O/U total)
 * @param {number} liveLine - current line (same convention as watchLine)
 * @returns {'good'|'bad'|'neutral'}
 */
export function getLineMovementSentiment(pickType, watchLine, liveLine) {
  if (watchLine == null || liveLine == null) return 'neutral';
  const movement = liveLine - watchLine;
  if (movement === 0) return 'neutral';

  switch (pickType) {
    case 'home':
      // Home spread moved down (e.g. -3 → -4.5): more points = better for home backer
      return movement < 0 ? 'good' : 'bad';
    case 'away':
      // Away benefits when spread moves up (e.g. -3 → -2.5)
      return movement > 0 ? 'good' : 'bad';
    case 'over':
      // Total went up: worse for over
      return movement > 0 ? 'bad' : 'good';
    case 'under':
      // Total went down: worse for under
      return movement < 0 ? 'bad' : 'good';
    default:
      return 'neutral';
  }
}

/**
 * @returns {number} Signed line delta (live - watch)
 */
export function calculateLineMovement(watchLine, liveLine) {
  return (liveLine ?? 0) - (watchLine ?? 0);
}
